// extracted by mini-css-extract-plugin
module.exports = {"button":"ControlButton_button__2Tty1","active":"ControlButton_active__2BrrO"};